import $service from '@/common/service/api-service';
import $config from '@/config';

function reLogin(res, args = {}) {
  res = res.code ? res : res.data;
  args.callback ? args.callback.call(this, res) : '';
}

export default {
  namespaced: true,
  state: {
    customersList: [],
    accountList: [],
    labels: [],
    crmInfo: {}
  },
  mutations: {
    setCustomersList(state, list) {
      state.customersList = list;
    },
    setAccountList(state, list) {
      state.accountList = list;
    },
    setCustomersLabels(state, labels) {
      state.labels = labels;
    },
    setCrmInfo(state, info) {
      info.contact ? '' : (info.contact = []);
      info.others ? '' : (info.others = {});
      info.labels ? '' : (info.labels = {});
      state.crmInfo = info;
    }
  },
  actions: {
    pullCustomersList(context, args = {}) {
      $service.get('/crm/customer', args.data).then(res => {
        if (res.code == 1) {
          context.commit('setCustomersList', res.data);
        };
        reLogin(res, args);
      })
    },
    pullDeletedCustomers(context, args = {}) {
      $service.get('/crm/customer/delete').then(res => {
        reLogin(res, args);
      })
    },
    recoverCustomer(context, args = {}) {
      $service.post('/crm/customer/recover/' + args.data).then(res => {
        reLogin(res, args);
      })
    },
    pullCustomerIds(context, args = {}) {
      $service.get('/crm/customer/origin/' + args.data + '/ids').then(res => {
        reLogin(res, args);
      })
    },
    pullAccountList(context, args = {}) {
      $service.get('/user/master/emailAccount/list').then(res => {
        if (res.code == 1) {
          context.commit('setAccountList', res.data);
        }
        reLogin(res, args);
      })
    },
    pullLabels(context, args = {}) {
      $service.get('/crm/customer/label', args.data).then(res => {
        if (res.code == 1) {
          context.commit('setCustomersLabels', res.data);
        };
        reLogin(res, args);
      })
    },
    addLabels(context, args = {}) {
      $service.post('/crm/customer/label', args.data).then(res => {
        reLogin(res, args);
      })
    },
    updateLabel(context, args = {}) {
      $service.post('/crm/customer/label/update', args.data).then(res => {
        reLogin(res, args);
      })
    },
    deleteLabel(context, args = {}) {
      $service.post('/crm/customer/label/delete/' + args.data).then(res => {
        reLogin(res, args);
      })
    },
    tagTargetCustomer(context, args = {}) {
      $service.post('/crm/customer/tag', args.data, {
        arrayFormat: 'comma'
      }).then(res => {
        reLogin(res, args);
      })
    },
    getCrmInfo(context, args = {}) {
      $service.get('/crm/customer/' + args.data).then(res => {
        if (res.code == 1) {
          context.commit('setCrmInfo', res.data);
        }
        reLogin(res, args);
      })
    },
    updateCustomerInfo(context, args = {}) {
      $service.jsonPost('/crm/customer/update', args.data).then(res => {
        reLogin(res, args);
      })
    },
    addCustomers(context, args = {}) {
      $service.jsonPost('/crm/customer', args.data).then(res => {
        reLogin(res, args);
      });
    },
    importCustomers(context, args = {}) {
      $service.jsonPost('/crm/customer/import', args.data).then(res => {
        const result = res.data;
        reLogin(res, args);
      })
    },
    deleteCustomers(context, args = {}) {
      if (args.data && args.data.ids) {
        $service.post('/crm/customer/delete', args.data, {
          arrayFormat: 'comma'
        }).then(res => {
          reLogin(res, args);
        })
      } else {
        $service.post('/crm/customer/delete/' + args.data).then(res => {
          reLogin(res, args);
        })
      }
    },
    abandonCustomers(context, args = {}) {
      $service.post('/crm/customer/abandon', args.data, {
        arrayFormat: 'comma'
      }).then(res => {
        reLogin(res, args);
      })
    },
    assignCustomers(context, args = {}) {
      $service.post('/crm/customer/assign', args.data, {
        arrayFormat: 'comma'
      }).then(res => {
        reLogin(res, args);
      })
    },
    obtainCustomers(context, args = {}) {
      $service.post('/crm/customer/obtain', args.data, {
        arrayFormat: 'comma'
      }).then(res => {
        reLogin(res, args);
      })
    },
    addFollowUpRecord(context, args = {}) {
      $service.post('/crm/customer/follow', args.data).then(res => {
        reLogin(res, args);
      })
    },
    pullFollowUpRecords(context, args = {}) {
      $service.get('/crm/customer/follow', args.data).then(res => {
        reLogin(res, args);
      })
    },
    deleteFollowUpRecord(context, args = {}) {
      $service.post('/crm/customer/follow/delete/' + args.data).then(res => {
        reLogin(res, args);
      })
    },
    pullEmailList(context, args = {}) {
      $service.get('/crm/email', args.data).then(res => {
        reLogin(res, args);
      })
    },
    deleteEmails(context, args = {}) {
      $service.post('/crm/email/delete', args.data, {
        arrayFormat: 'comma'
      }).then(res => {
        reLogin(res, args);
      })
    },
    importCustomerEmail(context, args = {}) {
      $service.jsonPost('/crm/email', args.data).then(res => {
        reLogin(res, args);
      })
    },
    pullCustomersStats(context, args = {}) {
      $service.get('/crm/customer/stats', args.data, {
        arrayFormat: 'repeat'
      }).then(res => {
        reLogin(res, args);
      })
    },
    pullTrackLables(context, args = {}) {
      $service.get('/crm/track/label', args.data).then(res => {
        reLogin(res, args);
      })
    },
    addTrackLabel(context, args = {}) {
      $service.post('/crm/track/label', args.data).then(res => {
        reLogin(res, args);
      })
    },
    deleteTrackLabel(context, args = {}) {
      $service.post('/crm/track/label/delete/' + args.data).then(res => {
        reLogin(res, args);
      })
    },
    editTrackLabel(context, args = {}) {
      $service.post('/crm/track/label/update', args.data).then(res => {
        reLogin(res, args);
      })
    },
    tagTrack(context, args = {}) {
      $service.post('/crm/track/tag', args.data, {
        arrayFormat: 'comma'
      }).then(res => {
        reLogin(res, args);
      })
    },
    deleteTrack(context, args = {}) {
      $service.post('/crm/track/delete/' + args.data).then(res => {
        reLogin(res, args);
      })
    },
    subscribeTrack(context, args = {}) {
      $service.post('/crm/track/subscribe', args.data).then(res => {
        reLogin(res, args);
      })
    },
    pullTrackedCustomers(context, args = {}) {
      $service.get('/crm/track', args.data, {
        arrayFormat: 'repeat'
      }).then(res => {
        reLogin(res, args);
      })
    },
    pullTradeSOInfo(context, args = {}) {
      $service.get('/crm/customer/so/com/' + args.data).then(res => {
        reLogin(res, args);
      })
    },
    pullShipmentsInfo(context, args = {}) {
      $service.get('/crm/customer/customs/com/' + args.data).then(res => {
        reLogin(res, args);
      })
    },
    pullRecordLatest(context, args = {}) {
      $service.post('/crm/track/record/latest', args.data, {
        arrayFormat: 'repeat'
      }).then(res => {
        reLogin(res, args);
      })
    },
    exportCustomerList(context, args = {}) {
      $service.get('/crm/customer/export', args.data).then(res => {
        reLogin(res, args);
      })
    }
  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/crm/index.js